import React from "react";
import TinderCard from "react-tinder-card";
import './SwipeableMarkets.css'
import { useTranslation } from "react-i18next";
import {CardPropsQuickbetX} from "../../helpers/helpers";

type SwipeDirection = "left" | "right" | "down" | "up";
const toCDNUrl = (pathname: string) => process.env.REACT_APP_CDN_URL + pathname;
const toAbsoluteCDN = (pathname: string) => process.env.REACT_APP_CDN_URL + pathname;
const toAssetsUrl = (pathname: string) => process.env.PUBLIC_URL + pathname;

export const UnifiedCardsComponentQuickbetX: React.FC<CardPropsQuickbetX> = ({
                                                               markets,
                                                               highlightOdds,
                                                               styles,
                                                               swipedMarkets,
                                                               childRefs,
                                                               onSwipe,
                                                               skipEvent,
                                                               onCardLeftScreen,
                                                               swipe,
                                                           }) => {
    const { t } = useTranslation();
    return (
        <div style={{ position: "relative", width: "90%", height: "450px", margin: "0 auto" }}>
            {markets.slice(0).reverse().map((market, reverseIndex) => {
                const index = markets.length - 1 - reverseIndex;
                const remainingCards = markets.length - swipedMarkets.length;
                const maxTranslateSpace = 470 - 460;
                const translateStep = maxTranslateSpace / Math.max(remainingCards - 1, 1);
                const dynamicTranslateY = Math.max((index - (markets.length - remainingCards)) * translateStep, 0);

                /*const swipeOptions: SwipeDirection[] =
                    market.market.bets.length === 3
                        ? (skipEvent ? ["up"] : [])
                        : (skipEvent ? ["up", "down"] : ["down"]);*/
                const preventSwipe: SwipeDirection[] = [];

                if (!skipEvent) {
                    preventSwipe.push("up");
                }

                if (market.market.bets.length !== 3) {
                    preventSwipe.push("down");
                }

                return (
                    <TinderCard
                        ref={childRefs[index]}
                        className="swipe"
                        key={`${market.id}-${market.market.market_code}`}
                        onSwipe={(dir:SwipeDirection) => onSwipe(dir, market, index)}
                        onCardLeftScreen={() => onCardLeftScreen(market.id, index)}
                        preventSwipe={preventSwipe}
                        swipeThreshold={50}
                        swipeRequirementType={"position"}
                    >
                        <div
                            className="swipableBlock"
                            style={{
                                position: "absolute",
                                width: "100%",
                                minHeight: "450px",
                                backgroundColor: styles.colors.blockTitleBgColor,
                                borderRadius: "10px",
                                boxShadow: "0 10px 20px rgba(0, 0, 0, 0.2)",
                                padding: "10px",
                                marginTop: "5px",
                                textAlign: "center",
                                zIndex: markets.length - index,
                                transform: `translateY(${dynamicTranslateY}px)`,
                                transition: "transform 0.3s ease-in-out",
                                border: `1px solid ${styles.colors.fontTitleColor}`,
                            }}
                        >
                            <div className="card-content">
                                <div
                                    className="mt-1 p-2 pt-3 rounded event-wrapper"
                                    style={{
                                        color: styles.colors.fontColor,
                                        fontSize: styles.fonts.mainFontSize,
                                    }}
                                >
                                    <div className="team">
                                        <img
                                            width="120"
                                            height="120"
                                            src={toAbsoluteCDN(`teams/${market.home_team.id}.png`)}
                                            onError={(e) => {
                                                const randomIndex = Math.floor(Math.random() * 5) + 1;
                                                e.currentTarget.src = toAssetsUrl(`/assets/img/tshirt${randomIndex}.png`);
                                            }}
                                            alt="logo"
                                        />
                                        <div className="mt-2 team-name" style={{color: styles.colors.fontTitleColor}}>
                                            {market.home_team.name}
                                        </div>
                                    </div>
                                    <div className="team">
                                        <img
                                            width="120"
                                            height="120"
                                            src={toAbsoluteCDN(`teams/${market.away_team.id}.png`)}
                                            onError={(e) => {
                                                const randomIndex = Math.floor(Math.random() * 5) + 1;
                                                e.currentTarget.src = toAssetsUrl(`/assets/img/tshirt${randomIndex}.png`);
                                            }}
                                            alt="logo"
                                        />
                                        <div className="mt-2 team-name" style={{color: styles.colors.fontTitleColor}}>
                                            {market.away_team.name}
                                        </div>
                                    </div>
                                </div>

                                <div className="rounded p-2 mt-3" style={{backgroundColor: styles.colors.blockBgColor}}>
                                    <div className="event-information">
                                        <img
                                            src={toCDNUrl(`leagues/${market.category.league_id}.png`)}
                                            onError={(e) => {
                                                e.currentTarget.src = toAssetsUrl('/assets/img/events/league/F2964C.png');
                                            }}
                                            alt="league-logo"
                                            style={{width: '40px', marginRight: '10px'}}
                                        />
                                        {market.category.league_name}
                                    </div>
                                    <div className="event-information-startTime mt-2">
                                        <div className="date">
                                            {new Date(market.starts).toLocaleString('en-GB', {
                                                day: 'numeric',
                                                month: 'short',
                                                year: 'numeric',
                                            })}
                                            <span style={{marginLeft: '5px'}}>
                                                {new Date(market.starts).toLocaleString('en-GB', {
                                                    hour: '2-digit',
                                                    minute: '2-digit',
                                                })}
                                                <i className="fa-regular fa-clock" style={{marginLeft: '5px'}}/>
                                            </span>
                                        </div>
                                    </div>
                                </div>

                                <div className="market-name"
                                     style={{color: styles.colors.fontTitleColor, fontWeight: "bold"}}>
                                    {t(`markets.${market.market.market_code}`)}
                                </div>

                                {/*<div className="mt-1 card-button-wrapper" style={{ backgroundColor: styles.colors.blockBgColor }}>*/}
                                {/*    {market.market.bets.map((bet: any, betIndex: number) => {*/}
                                {/*        const swipeDir = market.market.bets.length === 3*/}
                                {/*            ? (betIndex === 0 ? "left" : betIndex === 1 ? "down" : "right")*/}
                                {/*            : (betIndex === 0 ? "left" : "right");*/}
                                {/*        return (*/}
                                {/*            <button*/}
                                {/*                key={bet.id}*/}
                                {/*                className={`btn btn-${swipeDir} border pressable`}*/}
                                {/*                onClick={() => swipe(swipeDir)}*/}
                                {/*                style={{*/}
                                {/*                    backgroundColor: styles.colors.buttonBGColor,*/}
                                {/*                    color: styles.colors.buttonFontColor,*/}
                                {/*                }}*/}
                                {/*            >*/}
                                {/*                <div className="pressable">*/}
                                {/*                    {t(`bets.${bet.bet_name}`)}*/}
                                {/*                    {market.market.line_name && (*/}
                                {/*                        <span style={{ marginLeft: '5px' }}>{market.market.line_name}</span>*/}
                                {/*                    )}*/}
                                {/*                </div>*/}
                                {/*                <div className="pressable odds">{bet.odds}</div>*/}
                                {/*            </button>*/}
                                {/*        );*/}
                                {/*    })}*/}
                                {/*</div>*/}

                                <div className="mt-1 card-button-wrapper"
                                     style={{backgroundColor: styles.colors.blockBgColor}}>


                                    {market.market.bets.map((bet: any, betIndex: number) => {
                                        const swipeDir = market.market.bets.length === 3
                                            ? (betIndex === 0 ? "left" : betIndex === 1 ? "down" : "right")
                                            : (betIndex === 0 ? "left" : "right");
                                        return (
                                            <button
                                                key={bet.id}
                                                className={`btn btn-${swipeDir} border pressable`}
                                                onClick={() => {
                                                    // Перевіряємо, чи існує ref для поточної картки
                                                    if (childRefs[index]?.current) {
                                                        // Викликаємо метод .swipe() безпосередньо на ref верхньої картки
                                                        childRefs[index].current.swipe(swipeDir);
                                                    }
                                                }}
                                                style={{
                                                    backgroundColor: styles.colors.buttonBGColor,
                                                    color: styles.colors.buttonFontColor,
                                                    ...(highlightOdds && highlightOdds >= bet.odds
                                                        ? {
                                                            animation: 'pulseShadow 1s infinite',
                                                            boxShadow: `0 0 10px ${styles.colors.buttonFontColor}`,
                                                        }
                                                        : {})
                                                }}
                                            >
                                                <div className="pressable">
                                                    {t(`bets.${bet.bet_name}`)}
                                                    {market.market.line_name && (
                                                        <span
                                                            style={{marginLeft: '5px'}}>{market.market.line_name}</span>
                                                    )}
                                                </div>
                                                <div className="pressable odds">{bet.odds}</div>
                                            </button>
                                        );
                                    })}
                                </div>
                                <div>
                                    {skipEvent ? (
                                        <button
                                            className={`btn skip-btn border pressable`}
                                            onClick={() => {
                                                if (childRefs[index]?.current) {
                                                    childRefs[index].current.swipe("up");
                                                }
                                            }}
                                            style={{
                                                backgroundColor: styles.colors.buttonBGColor,
                                                color: styles.colors.buttonFontColor,
                                                marginTop: '5px',
                                                paddingRight: '30px'
                                            }}
                                        >
                                            {t('quickbet.priceBlock.nextEvent')}
                                        </button>
                                    ) : null}

                                </div>
                            </div>
                        </div>
                    </TinderCard>
                );
            })}
        </div>
    );
};
